import {combineReducers} from 'redux';
import views from './viewsReducer';
import data from './dataReducer';

export default combineReducers({
  views,
  data,
});
